import React, { useEffect, useRef } from 'react'
import StatementTextarea from './StatementTextarea'
import AddNewStatementButton from './AddNewStatementButton'

export default function AddNewStatementForm({ context }) {
    const {
        handleAddButtonClick,
        isAddButtonVisible,
        isTextareaVisible,
        handleSave,
        handleTextareaClose,
        setIsTextareaVisible,
        setIsAddButtonVisible,
        tags,
    } = context

    const formRef = useRef(null)

    // This form is the virtualized list's footer, so the panel-level "+ Add"
    // button can open it while the list is scrolled anywhere. Double rAF: the
    // first scroll lands near the footer using Virtuoso's height estimates,
    // the second corrects after the newly rendered rows are measured.
    useEffect(() => {
        if (!isTextareaVisible) return
        const node = formRef.current
        if (!node) return
        let raf2
        const raf1 = requestAnimationFrame(() => {
            node.scrollIntoView({ block: 'nearest' })
            raf2 = requestAnimationFrame(() =>
                node.scrollIntoView({ block: 'nearest' })
            )
        })
        return () => {
            cancelAnimationFrame(raf1)
            cancelAnimationFrame(raf2)
        }
    }, [isTextareaVisible])

    return (
        <div ref={formRef} style={{ position: 'relative', paddingBottom: '120px' }}>
            <AddNewStatementButton
                open={isAddButtonVisible}
                onOpen={handleAddButtonClick}
                onEnd={() => {
                    if (!isAddButtonVisible) {
                        setIsTextareaVisible(true)
                    }
                }}
            />
            <StatementTextarea
                initialText=""
                predefinedTags={tags}
                open={isTextareaVisible}
                voiceEnabled
                // The form stays open after a save so the user (or a running
                // voice dictation) can keep adding statements.
                onSave={handleSave}
                onCancel={handleTextareaClose}
                onEnd={() => {
                    if (!isTextareaVisible) {
                        setIsAddButtonVisible(true)
                    }
                }}
            />
        </div>
    )
}
